import { formRules } from "../../../../../config/validations/formRules";
import { validations } from "../../../../../config/validations/validations";

export const rules: any = {
    companyInitials: (field?: string) => [
        validations.required.text(field),
        validations.pattern.specialChar(),
        validations.pattern.numericValuesNotAllow(),
        validations.min.text(5),
        validations.max.text(5),
        // validations.pattern.numeric
    ],
    access_code: (field?: string) => [
		validations.required.text(field),
		validations.max.number(15),
		validations.min.number(5),
	],
    accessCodeCount: (field?:any) => [
        validations.required.text(field),
        // validations.min.number(1,field),
        // validations.max.number(999),
        validations.pattern.numeric
    ],
    startDate: (field?: string) => [validations.required.text(field)],
    endDate: (field?: string) => [validations.required.text(field)],
};
